import { ArrowRight } from "lucide-react";
import { useContent } from "../../context/ContentContext";

export default function HowItWorks() {
  const { c } = useContent();
  const h = c.howItWorks;
  return (
    <section className="bg-[var(--navy-900)] py-20 lg:py-24">
      <div className="mx-auto max-w-[1200px] px-5 lg:px-8">
        <div className="flex items-center gap-3">
          <p className="text-[12px] font-bold uppercase tracking-[0.14em] text-[#5aa0e0]">{h.eyebrow}</p>
          {h.badge && <span className="inline-flex items-center rounded-full bg-amber-400 px-3 py-1 text-[12px] font-bold text-[var(--navy)]">{h.badge}</span>}
        </div>
        <h2 className="font-display mt-3 text-[32px] font-extrabold tracking-tight text-white sm:text-[40px]">{h.title}</h2>
        <p className="mt-4 max-w-3xl text-[16px] leading-relaxed text-slate-400">{h.description}</p>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {h.steps.map((s, i) => (
            <div key={i} className="relative rounded-2xl border border-slate-200 bg-white p-6 shadow-[0_16px_40px_-24px_rgba(0,0,0,0.35)]">
              <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[var(--brand-blue)] font-display text-[18px] font-extrabold text-white">{i + 1}</div>
              <h3 className="font-display mt-5 text-[18px] font-bold text-[var(--ink)]">{s.title}</h3>
              <p className="mt-2 text-[14px] leading-relaxed text-slate-500">{s.body}</p>
              {i < h.steps.length - 1 && (
                <ArrowRight size={20} className="absolute -right-4 top-1/2 hidden -translate-y-1/2 text-white/20 lg:block" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
